<!--
 * @Descripttion: 行业词库弹窗
 * @Author: 陈文湘
 * @Date: 2020-07-16 14:34:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-07-22 14:07:00
 * @FilePath: \dzCloudc:\Users\Administrator\Documents\kuaio\src\components\industryTes\industryTes.vue
-->
<!-- 组件说明 -->
<template>
  <div class="industryTes">
    <el-dialog
      :visible.sync="industryTesVisible"
      width="744px"
      :lock-scroll="false"
      @open="openDialog"
      @closed="closedDialog"
      :before-close="close"
    >
      <div slot="title">
        <span class="font16 color333">更换行业</span>
      </div>
      <div class="mainView">
        <ul class="mainView_ul ml10" v-if="options.length > 0">
          <li
            class="mainView_li curp"
            v-for="(item, index) in options"
            :key="index"
            @mouseover="hoverIdFun(item.id)"
            @mouseout="outFun"
            @click="clickTes(item)"
            :class="[
              hoverId == item.id ? 'hoverClass' : '',
              selectVal.id == item.id ? 'seleClass' : '',
            ]"
          >
            <span class="font14 color333">{{ item.label }}</span>

            <img
              class="gouImg"
              v-show="selectVal.id == item.id"
              src="../../assets/gou.png"
              alt=""
            />
          </li>
        </ul>
        <p style="color:#FF6000;" class="font12 mt12 ml15">
          提示：由于部分行业没有特殊违禁词，所以暂无可选行业，检测通用词库即可
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$store.commit('industryTesVisibleFun', false)">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState } from "vuex";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      visibleDialog: true,
      options: [],
      hoverId: -1,
      selectVal: {},
      IndustryCategorys: [],
    };
  },
  //监控data中的数据变化
  watch: {},
  //监听属性 类似于data概念
  computed: {
    ...mapState(["industryTesVisible"]),
  },
  methods: {
    /**
     * @name: hoverIdFun
     * @Description: 行业hover效果
     * @param {string} id 移入的行业id
     * @return:
     * @Author: 陈文湘
     */

    hoverIdFun(id) {
      this.hoverId = id;
    },
    /**
     * @name: outFun
     * @Description: 移除hover事件
     * @param {}
     * @return:
     * @Author: 陈文湘
     */

    outFun() {
      this.hoverId = -1;
    },
    /**
     * @name: clickTes
     * @Description: 点击选中的行业
     * @param {object} v 选中的行业
     * @return:
     * @Author: 陈文湘
     */
    clickTes(v) {
      this.selectVal = v;
    },
    /**
     * @name: openDialog
     * @Description: 弹窗打开的方法,插入默认值
     * @param {}
     * @return:
     * @Author: 陈文湘
     */

    openDialog() {
      let self = this;
      self.GetIndustryCategorys();
    },
    /**
     * @name: closedDialog
     * @Description: 关闭弹窗方法
     * @param {}
     * @return:
     * @Author: 陈文湘
     */

    closedDialog() {
      this.selectVal = {};
      this.options = [];
    },
    /**
     * @name: confirm
     * @Description: 确认
     * @param {}
     * @return:
     * @Author: 陈文湘
     */

    confirm() {
      this.dialogVisible = false;
      let IndustryCategorys = ["通用"];
      // this.IndustryCategorys.splice(1, 1);

      if (this.selectVal.id != 0 && this.selectVal.hasOwnProperty("value")) {
        IndustryCategorys.push(this.selectVal.value);
      }
      if (this.selectVal.id && this.selectVal.id != 0) {
        this.$utils.buryingpoint("更换行业词库--" + this.selectVal.value + "--确定");
      }
      // userInfo.IndustryCategorys = this.IndustryCategorys;
      this.$utils.setKuaioIdConfig("IndustryCategorys", IndustryCategorys);
      this.$utils.setKuaioIdConfig("seleCheckThes", IndustryCategorys);
      this.$store.commit("industryTesVisibleFun", false);
      this.$store.commit("checkThesTextFun");
    },
    /**
     * @name: GetIndustryCategorys  API类
     * @Description: 获取违禁词行业类目数据
     * @param {}
     * @return:
     * @Author: 陈文湘
     */

    GetIndustryCategorys() {
      let self = this;
      self.$ajax
        .get("/kuaio/api/ForbiddenWord/Manager/GetIndustryCategorys")
        .then(function(res) {
          if (res.code == 200) {
            self.options.push({
              label: "默认不选行业",
              value: "默认不选行业",
              id: "0",
            });
            res.result.map((item, index) => {
              let str = {
                value: "",
                label: "",
                id: "",
              };
              str.value = item;
              str.label = item;
              str.id = index + 1;
              self.options.push(str);
            });
            let IndustryCategorys = self.$utils.getKuaioIdConfig().IndustryCategorys;
            self.IndustryCategorys = IndustryCategorys;
            if (IndustryCategorys.length > 1) {
              IndustryCategorys.map((item, index) => {
                self.options.map((val, inx) => {
                  if (item == val.value) {
                    self.selectVal = val;
                  }
                });
              });
            }
          }
        })
        .catch(function() {});
    },
    /**
     * @name: close
     * @Description: 关闭方法
     * @param {}
     * @return:
     * @Author: 陈文湘
     */

    close() {
      this.$store.commit("industryTesVisibleFun", false);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let self = this;
  },
};
</script>

<style lang="scss" scoped>
//@import url()
.mainView_ul {
  display: flex;
  flex-wrap: wrap;
  .mainView_li {
    width: 120px;
    height: 36px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    border-radius: 2px;
    text-align: center;
    line-height: 36px;
    margin: 8px 8px;
    font-size: 14px;
    color: #333333;
    position: relative;
    .gouImg {
      position: absolute;
      bottom: -1px;
      right: -1px;
    }
  }
  .hoverClass {
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(28, 100, 244, 1);
    span {
      color: #1c64f4;
    }
  }
  .seleClass {
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(28, 100, 244, 1);
  }
}
</style>
